module.exports = __webpack_public_path__ + "img/confirm-vo.1988296e.svg";